import type { CaseSchedule } from '@/types';
import { formatDate, formatTime, scheduleColorClass } from './shared';

/* ─── Schedule Tab ─── */

export function ScheduleTab({ schedules }: { schedules: CaseSchedule[] }) {
    if (schedules.length === 0) {
        return <p className="py-8 text-center text-[13px] text-[#999]">No schedules found.</p>;
    }

    const grouped = schedules.reduce<Record<string, CaseSchedule[]>>((acc, s) => {
        const key = formatDate(s.scheduledDate);
        (acc[key] ??= []).push(s);
        return acc;
    }, {});

    return (
        <div className="space-y-5">
            {Object.entries(grouped).map(([date, events]) => (
                <div key={date} className="rounded-xl border border-[#eee] p-5">
                    <h3 className="mb-4 text-[14px] font-bold text-secondary">{date}</h3>
                    <div className="divide-y divide-background">
                        {events.map((event) => (
                            <div key={event.id} className="flex items-center gap-4 py-3">
                                <span className="text-[12px] text-[#888]">{formatTime(event.scheduledTime)}</span>
                                <div className={`h-8 w-1 rounded-full ${scheduleColorClass(event.color)}`} />
                                <div>
                                    <p className="text-[12px] font-semibold text-secondary">{event.title}</p>
                                    {event.note && <p className="text-[10px] text-primary">{event.note}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
